"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function BlogHero() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#fefce8] py-16 text-center">
      <div className="mx-auto max-w-3xl px-6">
        <span className="mb-3 inline-block text-xs font-bold uppercase tracking-widest text-[#064e3b]/60">
          {t("blog.eyebrow")}
        </span>
        <h1 className="mb-4 text-5xl font-bold text-[#064e3b]">
          {t("blog.h1")}
        </h1>
        <p className="text-lg text-[#064e3b]/60">
          {t("blog.subhead")}
        </p>
      </div>
    </section>
  );
}